import { useControlledState } from '../../hooks/useControlledState';
/**
 * Represents the available `action` types for the `SchedulerItemSeriesAction` objects.
 *
 * The available actions are:
 * - `SERIES_RESET`
 * - `SERIES_SET`
 * - `SERIES_TOGGLE`
 */
export var SERIES_ACTION;
(function (SERIES_ACTION) {
    SERIES_ACTION["reset"] = "SERIES_RESET";
    SERIES_ACTION["set"] = "SERIES_SET";
    SERIES_ACTION["toggle"] = "SERIES_TOGGLE";
})(SERIES_ACTION || (SERIES_ACTION = {}));
var seriesReducer = function (state, action) {
    switch (action.type) {
        case SERIES_ACTION.reset:
            return null;
        case SERIES_ACTION.set:
            return action.payload;
        case SERIES_ACTION.toggle:
            return !state;
        default:
            return state;
    }
};
/** @hidden */
export var useSeries = function (defaultProp, prop, callback) {
    var _a = useControlledState(defaultProp, prop, callback), series = _a[0], setSeries = _a[1];
    var handleSeriesAction = function (action) {
        var newSeries = seriesReducer(series, action);
        setSeries(newSeries);
    };
    return [series, setSeries, handleSeriesAction];
};
//# sourceMappingURL=use-series.js.map